import {
  useMutation,
  useQueryClient,
  type UseMutateFunction,
  type UseMutateAsyncFunction,
} from '@tanstack/react-query';
import { candidateService } from '../services/candidate.service';
import type { Candidate } from '../types/candidate.types';

export function useResendInvitation(): {
  resendInvitation: UseMutateFunction<Candidate, Error, string>;
  resendInvitationAsync: UseMutateAsyncFunction<Candidate, Error, string>;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  error: Error | null;
} {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (id: string) => candidateService.resendInvitation(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['candidates'] });
    },
  });
  return {
    resendInvitation: mutation.mutate,
    resendInvitationAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
  };
}
